module.exports = __webpack_public_path__ + "static/media/gotham-medium.12acaf39.woff2";